<template>
  <div class="forecast-step">
    <b-row>
      <b-col cols="4">
        <div class="modal-block-title">Asset Metrics:</div>
        <ul class="asset-metrics">
          <li><span>Type of Oracle:</span> <span>{{ forecastData.forecast.oracle }}</span></li>
          <li><span>Current Price:</span> <span>$ {{ asset.price.value | formatPrice }}</span></li>
          <li><span>Volume:</span> <span>$ 81.76M</span></li>
          <li><span>Marcet Cap.:</span> <span>$ 2.26B</span></li>
          <li><span>Evaluation Date:</span> <span>{{ forecastData.forecast.forecastDate | formatForecastDate }}</span></li>
        </ul>
      </b-col>
      <b-col cols="8">
        <div class="wrapp">
          <div class="modal-block-title">Your Evaluation is:</div>
          <div class="input-group">
            <div class="p-input">
              <div class="label">Change in %</div>
              <div class="input-wrapper">
                <input type="number" v-model="valuePercent" min="-100" @change="onPercentChange">
              </div>
            </div>
            <div class="p-input">
              <div class="label">Value after your evaluation</div>
              <div class="input-wrapper">          
                <input type="number" v-model="valueAbs" min="0" @change="onAbsChange">
                <div class="p-input-suffix">USD</div>            
              </div>
            </div>
          </div>
          <div class="result-change" :class="{ up: changeValue > 0, down: changeValue < 0 }">
            <div class="label">Change is:</div>
            <div class="value">{{ changeValue }}</div>
            <div class="suffix">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
                <path class="st0" d="M36.9,0H12.2c-0.8,0-1.6,0.3-2.2,0.9C9.5,1.5,9.2,2.2,9.2,3.1c0,0.8,0.3,1.6,0.9,2.2l8.5,8.5L0.5,31.8
                  C0.2,32.1,0,32.5,0,32.9c0,0.4,0.2,0.8,0.5,1.1L6,39.5C6.3,39.8,6.7,40,7.1,40c0.4,0,0.8-0.2,1.1-0.5l18.1-18.1l8.5,8.5
                  c0.6,0.6,1.3,0.9,2.2,0.9c0.8,0,1.6-0.3,2.2-0.9c0.6-0.6,0.9-1.3,0.9-2.2V3.1c0-0.8-0.3-1.6-0.9-2.2C38.5,0.3,37.8,0,36.9,0z"/>
              </svg>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="modal-footer">
      <e-button type="outlined" @click="cancel">Cancel</e-button>        
      
      <div class="d-flex ml-auto">
        <e-button :disabled="isDisabledNext" @click="next">Set</e-button>        
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import moment from 'moment';

export default {
  name: "step-create-forecast",
  components: { },
  filters: {
    formatForecastDate(date) {
      return moment(date).format('DD MMM. YYYY');
    },
    formatPrice(price) {
        price = parseFloat(price);
        if(price <= 10) {
          return price.toFixed(6);
        } else if(price <= 50) {
          return price.toFixed(4);          
        }

        return price.toFixed(2)        
      }
  },
  data() {
    return {
      valuePercent: 0,
      valueAbs: 0,
    };
  },
  methods: {
    ...mapMutations('forecast', {
      setPrediction: 'setPrediction'
    }),
    nextPage(type) {
      this.$emit('nextPage', type);
    },
    onPercentChange(v) {
      this.valueAbs = ((this.asset.price.value / 100) * parseFloat(this.valuePercent) + this.asset.price.value).toFixed(4);
    },
    onAbsChange(v) {
      this.valuePercent = ((parseFloat(this.valueAbs) * 100 / this.asset.price.value) - 100).toFixed(2);
    },
    cancel() {
      this.$emit('closeModal');
    },
    next() {
      this.setPrediction({
        absolute: this.valueAbs,
        percent: this.valuePercent,
        change: this.changeValue,
      });
      
      this.$emit('nextPage');
    },
  },
  computed: {
    ...mapGetters('forecast', {
      forecastData: 'forecastModalData'
    }),
    asset() {
      return this.forecastData !== null ? this.forecastData.asset : null;
    },
    changeValue() {
      if(parseFloat(this.valueAbs) === 0) {
        return (0).toFixed(4);
      }

      return (parseFloat(this.valueAbs) - parseFloat(this.asset.price.value)).toFixed(4);
    },
    isDisabledNext() {
      return +this.valuePercent === 0;
    }
  },
  mounted() {
    // this.fetchCoins();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/modals/forecast/stepCreateForecast.vue